import { AnyAction } from 'redux';
import * as actionTypes from './notification.actions';

type NotificationState = {
  message: string | null;
  severity: 'info' | 'success' | 'warning' | 'error';
  top?: number;
};

const initialState: NotificationState = {
  message: null,
  severity: 'info', // success | error | warning | info
  top: undefined,
};

const notificationReducer = (state: NotificationState = initialState, action: AnyAction): NotificationState => {
  switch (action.type) {
    case actionTypes.NOTIFICATION_SHOW:
      return {
        ...state,
        ...action.payload,
      };
    case actionTypes.NOTIFICATION_HIDE:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

export default notificationReducer;
